import { Component, OnInit,AfterViewInit, Inject,Output,Input,EventEmitter, Renderer2, ElementRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Http, Headers, RequestOptions } from '@angular/http';
import { DomSanitizer } from "@angular/platform-browser"

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss']
})
export class LoadingModalComponent implements OnInit {

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  // @Input() confirmaction;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      message: any,
      title: string,
      type: string,
      cancellable: boolean,
      confirm:string
      close:string
      confirm_action,
      cancel_action,
      cancel_text_normal:boolean,
      closeModal: any
      // asInnerHTML:boolean
  },
  private mdDialogRef: MatDialogRef<LoadingModalComponent>,
  private dialog:MatDialog,
  public sanitizer: DomSanitizer,
  private renderer: Renderer2, 
  private el: ElementRef
  ) { }
  color;
  showCancel = true;
  ngOnInit() {
    this.color="green";
    setTimeout(() => {
      if (!this.data.cancellable) {
        setTimeout(() => {
          this.data.cancellable = true;
          this.showCancel = false;
        }, 55000);
      }
    }, 2000);
    this.isActive()
  }

  ngAfterViewInit() {
    if (this.data.type.toLocaleLowerCase()=='alert' || this.data.type.toLocaleLowerCase()=='prepaid alert') {
      
      document.getElementById('mainmessage').innerHTML = this.data.message;
    } 
  }
  


  public close(value) {
    this.mdDialogRef.close(value);
    this.mdDialogRef=undefined
    this.passEntry.emit(false);
    this.spinner=false
    this.activespinner=false

  }
  public confirm() {
    // this.confirmaction()
    this.close(true);
    this.passEntry.emit(true);
    this.spinner=false
    this.activespinner=false

  }
  destroy(value){
    this.mdDialogRef.close(value);
    this.passEntry.emit(false);
    this.mdDialogRef=undefined
    this.spinner=false;
    this.activespinner=false;

  }

  public setinactive(){
    this.activespinner=false
  }
  
  public isActive(){
    this.activespinner=true
    setTimeout(() => {
      if(this.data.type=="prepaid alert"){
        this.createContainer();
        this.poof();
      }
    }, 200);
    return this.activespinner
  }
  public loadingbar(){
    this.spinner=true
    this.activespinner=false
  }

  spinner=false
  activespinner=false
  canceltext="Cancel"
  confirmtex="Confirm"




  private container!: HTMLDivElement;
  private confetti: any[] = [];
  private timer: any;
  private frame: number | undefined;

  // Configuration settings
  private particles = 10;
  private spread = 40;
  private sizeMin = 3;
  private sizeMax = 12 - this.sizeMin;
  private eccentricity = 10;
  private deviation = 100;
  private dxThetaMin = -0.1;
  private dxThetaMax = -this.dxThetaMin - this.dxThetaMin;
  private dyMin = 0.13;
  private dyMax = 0.18;
  private dThetaMin = 0.4;
  private dThetaMax = 0.7 - this.dThetaMin;

   // Utility to create random RGB colors
   private randomColor(): string {
    const r = Math.floor(Math.random() * 200);
    const g = Math.floor(Math.random() * 200);
    const b = Math.floor(Math.random() * 200);
    return `rgb(${r}, ${g}, ${b})`;
  }

  private createContainer(): void {
    this.container = this.renderer.createElement('div');
    this.renderer.setStyle(this.container, 'position', 'fixed');
    this.renderer.setStyle(this.container, 'top', '0');
    this.renderer.setStyle(this.container, 'left', '0');
    this.renderer.setStyle(this.container, 'width', '100%');
    this.renderer.setStyle(this.container, 'height', '0');
    this.renderer.setStyle(this.container, 'overflow', 'visible');
    this.renderer.setStyle(this.container, 'zIndex', '9999');

    this.renderer.appendChild(this.el.nativeElement, this.container);
  }

  private createConfetto(): any {
    const confetto: any = {};
    confetto.frame = 0;

    const outer = this.renderer.createElement('div');
    const inner = this.renderer.createElement('div');
    this.renderer.appendChild(outer, inner);

    // Outer and inner styles
    const size = this.sizeMin + this.sizeMax * Math.random();
    this.renderer.setStyle(outer, 'position', 'absolute');
    this.renderer.setStyle(outer, 'width', `${size}px`);
    this.renderer.setStyle(outer, 'height', `${size}px`);
    this.renderer.setStyle(inner, 'width', '100%');
    this.renderer.setStyle(inner, 'height', '100%');
    this.renderer.setStyle(inner, 'backgroundColor', this.randomColor());

    this.renderer.setStyle(outer, 'perspective', '50px');
    confetto.axis = `rotate3D(${Math.cos(360 * Math.random())}, ${Math.cos(360 * Math.random())}, 0, `;
    confetto.theta = 360 * Math.random();
    confetto.dTheta = this.dThetaMin + this.dThetaMax * Math.random();
    this.renderer.setStyle(inner, 'transform', `${confetto.axis}${confetto.theta}deg)`);

    confetto.x = window.innerWidth * Math.random();
    confetto.y = -this.deviation;
    confetto.dx = Math.sin(this.dxThetaMin + this.dxThetaMax * Math.random());
    confetto.dy = this.dyMin + this.dyMax * Math.random();

    this.renderer.setStyle(outer, 'left', `${confetto.x}px`);
    this.renderer.setStyle(outer, 'top', `${confetto.y}px`);

    confetto.outer = outer;
    confetto.inner = inner;

    return confetto;
  }

  private poof(): void {
    if (!this.frame) {
      const theme = () => this.randomColor();
      const addConfetto = () => {
        const confetto = this.createConfetto();
        this.confetti.push(confetto);
        this.renderer.appendChild(this.container, confetto.outer);
        this.timer = setTimeout(addConfetto, this.spread * Math.random());
      };
      addConfetto();

      let prev: number | undefined;

      const loop = (timestamp: number) => {
        const delta = prev ? timestamp - prev : 0;
        prev = timestamp;

        const height = window.innerHeight;

        for (let i = this.confetti.length - 1; i >= 0; i--) {
          const confetto = this.confetti[i];
          confetto.frame += delta;
          confetto.x += confetto.dx * delta;
          confetto.y += confetto.dy * delta;
          confetto.theta += confetto.dTheta * delta;

          this.renderer.setStyle(confetto.outer, 'left', `${confetto.x}px`);
          this.renderer.setStyle(confetto.outer, 'top', `${confetto.y}px`);
          this.renderer.setStyle(confetto.inner, 'transform', `${confetto.axis}${confetto.theta}deg)`);

          if (confetto.y > height + this.deviation) {
            this.renderer.removeChild(this.container, confetto.outer);
            this.confetti.splice(i, 1);
          }
        }

        if (this.timer || this.confetti.length) {
          this.frame = requestAnimationFrame(loop);
        } else {
          this.cleanup();
        }
      };

      this.frame = requestAnimationFrame(loop);
    }
  }

  private cleanup(): void {
    if (this.frame) {
      cancelAnimationFrame(this.frame);
      this.frame = undefined;
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
    this.confetti.forEach(confetto => {
      this.renderer.removeChild(this.container, confetto.outer);
    });
    this.confetti = [];
    this.renderer.removeChild(this.el.nativeElement, this.container);
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/modals/loading-modal/loading-modal.component.ts